module.exports = {"130971400":"开发区乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130971.json
// module id = 312
// module chunks = 0